import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

// Shared empty-state row/block (Phase A promotion, module 11 polish pass).
// Donor: ManageMembers empty table row ("py-8 text-center text-sm
// font-semibold text-gray-500" inside a colSpan cell); inline-block variant in
// InvoiceLineItemsTable. Copy stays caller-owned — filter-aware strings
// (e.g. ManageEvents' two-message variant) live in the pages.

export type EmptyStateProps = {
  message: React.ReactNode;
  /** Set to render the MUI <TableRow><TableCell colSpan> wrapper (manage tables) */
  colSpan?: number;
  className?: string;
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  colSpan,
  className = "py-8 text-center text-sm font-semibold text-gray-500",
}) => {
  if (colSpan !== undefined) {
    return (
      <TableRow>
        <TableCell colSpan={colSpan} className={className}>
          {message}
        </TableCell>
      </TableRow>
    );
  }

  return <div className={className}>{message}</div>;
};
